Mailcheck = require('mailcheck')
require('bijou/base')

"use strict"

$.widget "chopin.mailcheck", $.bijou.base,
  _create: ->
    @controlBlock = @element.closest('.control-block')

    @customDomains = []
    @customSecondLevelDomains = ["gmail", "hotmail", "yahoo", "btinternet",
      "live", "outlook", "aol", "sky", "googlemail", "icloud", "ntlworld",
      "talktalk", "me", "msn", "tiscali", "mail", "ymail", "blueyonder",
      "virginmedia", "btconnect", "btopenworld", "rocketmail", "fsmail", "wp",
      "talk21", "abv", "mac", "tesco", "gmx", "virgin", "o2", "uwclub", "tlen",
      "lineone", "email", "interia", "op", "orange", "doctors", "nhs", "inbox",
      "supanet", "onetel", "homecall", "mypostoffice", "onet", "easy", "bbc",
      "bt", "gov", "qq", "skype", "aim"
      "cam", "open", "qub", "kent", "uel", "bath", "my" # academic domains
    ]
    @customTopLevelDomains = ["com", "co.uk", "net", "pl", "bg", "ru", "org.uk",
      "co.in", "lv", "it", "fr", "com.au", "eu", "ie", "es", "ro", "fm", "cz",
      "hu", "ca", "de", "sk", "hk", "ac.uk", "net.uk", "coop", "gr", "co.nz",
      "lt", "uk", "edu.sa", "com.br", "in", "co.jp", "com.pt", "pt", "nl",
      "com.sg", "se", "gov.uk", "co.za", "cn", "org", "us", "ch", "nhs.uk",
      "vn", "edu", "dk", "mod.uk", "info", "at", "com.tr", "com.tw", "uk.com",
      "cc", "no", "cy", "ar", "ae", "co"]
    
    @doMailcheck(@displaySuggestion.bind(this), @element)

    @_on
      "change": (e) ->
        @doMailcheck(@displaySuggestion.bind(this), @element)

  doMailcheck: (displaySuggestion, element) ->
    atMissingErrorMsg     = 'Please include "@" in your email address.'

    originalErrorLabel    = @controlBlock.find('span.error')
    atMissingErrorLabel   = @controlBlock.find('span.at-missing-error-msg')
    mailcheckWarningLabel = @controlBlock.find('span.suggestion')

    if (element.val().length > 0 && element.val().indexOf('@') == -1)
      if (element.hasClass('dont-override-error-message'))
        newLabel = $("<span>").attr({
          id : "at-missing-error-msg",
          class : 'error at-missing-error-msg',
        }).text(element[0].dataset.msg)
      else
        instructionsText = '\n"'+ element.val() + '" is missing "@"'
        newLabel = $("<span>").attr({
          id : "at-missing-error-msg",
          class : 'error at-missing-error-msg',
        }).text(atMissingErrorMsg + instructionsText)

      element.attr("aria-describedby", "at-missing-error-msg")
      originalErrorLabel.remove()
      @controlBlock.append(newLabel)

    else
      atMissingErrorLabel.remove()
      element.removeAttr("aria-describedby")
      originalErrorLabel.show()

    Mailcheck.run
      email: element.val()
      domains: @customDomains
      topLevelDomains: @customTopLevelDomains
      secondLevelDomains: @customSecondLevelDomains
      suggested: (suggestion) ->
        originalErrorLabel.remove()
        displaySuggestion(suggestion, element)
        element.attr("aria-describedby", "did-you-mean-error-msg")
      empty: () ->
        element.removeAttr("aria-describedby")
        mailcheckWarningLabel.remove()

  displaySuggestion: (suggestion, element) ->
    @controlBlock = element.closest('.control-block')

    if(@controlBlock.find('span.suggestion').length > 0)
      @controlBlock.find('span.suggestion').remove()

    EventTracker.trigger(
      "email_suggestion_displayed",
      suggestion.full,
      element.val()
    )

    newLabel = $("<span>").attr({
      id : "did-you-mean-error-msg",
      class : 'suggestion mailcheck',
      }).text("Did you mean ")
      .append("<span class='suggestion-email'>"+suggestion.full+"</span>?")
      .append("<button aria-label='Change to suggested email' " +
              "class='suggestion-email-change'>Change.</button>")

    newLabel.on 'click', ->
      EventTracker.trigger("email_suggestion_clicked", suggestion.full)
      element.val(suggestion.full)
      element.removeClass('error')
      element.removeAttr("aria-describedby")
      newLabel.remove()

    @controlBlock.append(newLabel)
